<template>
  <div class="pass-infants-table">
    <table class="order-default-table">
      <thead>
      <tr>
        <td v-if="selectAble"></td>
        <td>携带婴儿</td>
        <td>出生日期</td>
        <td>航段</td>
        <!-- <td>单价</td> -->
        <td>票号</td>
        <td>退改签</td>
        <td>总票价</td>
      </tr>
      </thead>
      <tbody>
      <template v-for="(infant, infantIndex) in infants">
        <template v-for="(infantSeg, infantSegIndex) in infant.flightSegments" >
          <tr
              :key="infantIndex + '' + infantSegIndex"
              :class="{'infant-no-acl-tr': !infantSeg.ancillaries.length }"
          >
            <td
              v-if="selectAble"
              :rowspan="infantSeg.ancillaries.length ? 2 : 1"
              class="infant-checkbox-td"
              :class="{'infant-checkbox-exs-td': infantSeg.ancillaries.length }"
            >
              <a-checkbox
                :checked="infantSeg.checked"
                :disabled="['RR', 'HK', 'HL'].indexOf(infantSeg.status) < 0 "
                @change="onChange($event, infant, infantSeg)"></a-checkbox>
            </td>
            <td>{{ infant.fullName }}</td>
            <td>{{ infant.birthDay }}</td>
            <td>{{ infantSeg.departureName }}-{{infantSeg.arrivalName}}</td>
            <!-- <td>{{ infantSeg.totalAmount }}元</td> -->
            <td>{{ infantSeg.ticketNo ? infantSeg.issCode + '-' + infantSeg.ticketNo : '--' }}</td>
            <td>
              <span>免费</span>
            </td>
            <td v-if="(ifInternational?.() && infantSegIndex === 0) || !ifInternational?.()"
              :rowspan="ifInternational?.() && infantSegIndex === 0 ? infant.flightSegments.length : 1"
              :class="{'infant-td': ifInternational?.()}"
            >
              <tax-popover :passenger="infant" :segment="infantSeg" :ifInternational="ifInternational?.()"></tax-popover>
            </td>
          </tr>
          <tr :key="infantIndex + '_' + infantSegIndex"
              class="infant-ext-tr"
              v-if="infantSeg.ancillaries.length">
            <td colspan="5"
                class="infant-ext-td">
              <ExtendInfo
                :seg="infantSeg"
                :order="order"
                v-bind="$attrs"
              ></ExtendInfo>
            </td>
          </tr>
        </template>
      </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import ExtendInfo from './ExtendInfo'
import taxPopover from './tax-popover.vue'

export default {
  name: 'PassengerInfants',
  props: {
    order: {
      type: Object,
      default: function () {
        return {}
      }
    },
    infants: {
      type: Array,
      default: function () {
        return {}
      }
    },
    selectAble: {
      type: Boolean,
      default: function () {
        return true
      }
    }
  },
  inject: {
    ifInternational: {
      value: 'ifInternational',
      default: null
    }
  },
  methods: {
    onChange: function (e, pass, seg) {
      this.$emit('seg-change', e, pass, seg)
    }
  },
  components: {
    ExtendInfo,
    taxPopover
  }
}
</script>
